export const isIsoDateString = (candidate: string): candidate is string =>
  _isoDateRegex.test(candidate) && !Number.isNaN(Date.parse(candidate));

const _isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/;
